var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8594 1.4541H2.10938C0.942141 1.4541 0 2.39624 0 3.56348V12.001C0 13.1681 0.942141 14.1104 2.10938 14.1104H2.8125V16.2197C2.8125 16.7277 3.33848 17.0956 3.85312 16.8385C3.86719 16.8244 3.89536 16.8244 3.90942 16.8103C7.77736 14.2165 6.9105 14.7948 7.77661 14.2228C7.88906 14.1525 8.01562 14.1104 8.15625 14.1104H14.8594C16.0266 14.1104 16.9688 13.1681 16.9688 12.001V3.56348C16.9688 2.39624 16.0266 1.4541 14.8594 1.4541ZM9.23438 9.8916H3.51562C2.58877 9.8916 2.58497 8.48535 3.51562 8.48535H9.23438C10.1612 8.48535 10.165 9.8916 9.23438 9.8916ZM13.4531 7.0791H3.51562C2.58877 7.0791 2.58497 5.67285 3.51562 5.67285H13.4531C14.38 5.67285 14.3838 7.0791 13.4531 7.0791Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 7.0791H18.375V12.001C18.375 13.9416 16.8 15.5166 14.8594 15.5166H8.36719L7.03125 16.4025V17.626C7.03125 18.7931 7.97339 19.7354 9.14062 19.7354H16.0546L20.0906 22.4353C20.6415 22.7412 21.1875 22.3692 21.1875 21.8447V19.7354H21.8906C23.0579 19.7354 24 18.7931 24 17.626V9.18848C24 8.02129 23.0579 7.0791 21.8906 7.0791Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.78c143ec79968c422889a4d76163819a.svg";
export { ForwardRef as ReactComponent };